export const sps = [
  {
    "titulo_item_nombre": "Indicadores de desempeño del Programa Caravanas de la Salud 2018",
    "archivos": [
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "CONVENIO DE TRANSFERENCIA DE RECURSOS FAM 2018",
        "file_item_url": "../../contenido/transparencia/sps/DGPLADES-FAM-CECTR-HGO-01-18.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "UNIDADES MEDICAS MÓVILES 2015",
        "file_item_url": "../../contenido/transparencia/sps/ANEXO 7, UNIDADES MEDICAS MOVILES 2015.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "UNIDADES MEDICAS MÓVILES 2014",
        "file_item_url": "../../contenido/transparencia/sps/ANEXO 7, CARAVANAS DE LA SALUD 2014.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "UNIDADES MEDICAS MÓVILES 2013",
        "file_item_url": "../../contenido/transparencia/sps/ANEXO 7, CARAVANAS DE LA SALUD 2013.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "UNIDADES MEDICAS MÓVILES 2012",
        "file_item_url": "../../contenido/transparencia/sps/ANEXO 7, CARAVANAS DE LA SALUD 2012.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "UNIDADES MEDICAS MÓVILES 2011",
        "file_item_url": "../../contenido/transparencia/sps/ANEXO 7, CARAVANAS DE LA SALUD 2011.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "UNIDADES MEDICAS MÓVILES 2010",
        "file_item_url": "../../contenido/transparencia/sps/ANEXO 7, CARAVANAS DE LA SALUD 2010.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "Convenio para el Programa Regulación y Vigilancia de Establecimientos y Servicios de Atención Médica",
    "archivos": [
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "Convenio DGCES-CETR-HGO-G005-17",
        "file_item_url": "../../contenido/transparencia/sps/Convenio DGCES-CETR-HGO-G005-17.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "Avance Financiero cuarto trimestre 2017",
        "file_item_url": "../../contenido/transparencia/sps/MX-M283N_20180327_141259.pdf"
      }
    ]
  }
  
  
]